import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import "../assets/css/tanseeq.css"

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({ title, children }) => (
  <>
    <Row>
      <Col xs={12} className="section-header">
        {title}
      </Col>
    </Row>
    {children}
  </>
);